// api
import { imageAPI } from '@fluke/baseline-client-apis';

// utilities
import { getAssetsFromUrl } from '../../../utils/getAssetsFromUrl';

export default function handleImageLoad({
  selectedImageIds = [],
  setLoadedData = null,
  updateGroupImageData = null,
  onLoad = null,
  currentOrganization = '',
}) {
  const loadDataFromURL = async (imageData = {}) => {
    const { s3_keys = {}, image_id = '', sort_info = {} } = imageData;
    const { info = '', visual = '', irdata = '', preview = '', photonotes = [] } = s3_keys;

    const newData = await getAssetsFromUrl({
      info: {
        url: `${info}`,
        responseType: 'json',
      },
      visual: {
        url: `${visual}`,
        responseType: 'arraybuffer',
      },
      irdata: {
        url: `${irdata}`,
        responseType: 'arraybuffer',
      },
      preview: {
        url: `${preview}`,
        responseType: 'arraybuffer',
      },
    });

    newData['id'] = image_id;
    const nextIndex = selectedImageIds.indexOf(image_id);
    updateGroupImageData?.(image_id, { sort_info, photonotes });

    if (nextIndex !== -1) {
      setLoadedData((prev) => {
        const _data = [...prev];
        _data[nextIndex] = { ..._data[nextIndex], data: newData };
        return _data;
      });
    }
  };

  const fetchImagesById = async () => {
    let isDone = false;

    if (selectedImageIds.length > 0) {
      // initial array population
      const initialData = selectedImageIds.map((id) => ({ id, data: {} }));
      setLoadedData?.(initialData);

      // segmented fetch and load union
      for (const imageId of selectedImageIds) {
        try {
          const data = await imageAPI.fetchById(imageId, currentOrganization);
          loadDataFromURL?.(data[0]);
        } catch (error) {
          console.error(`Failed to fetch image for: ${imageId}`, error);
        }
      }

      // const { data } = await imageAPI.fetchByMultipleIds(selectedImageIds);
      // for (const image of data) {
      //   loadDataFromURL([image]);
      // }

      isDone = true;
    }
    // completed image load
    onLoad?.(isDone);
  };

  fetchImagesById();
}
